import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { EstatusJSON } from "../../models/EstatusJSON";
import { IApiBase } from "./Interface/IApiBase.interface";
import { CatalogPaginationRequest } from "../../models/CatalogPagination/CatalogPaginationRequest";
import { FilterRequest } from "../../models/Filter/FilterRequest";
import { TerritoriesFiltersSelected } from "src/app/features/map-features/sections/territories-section/Models/TerritoriesFilters";
import { TerritoriesListItem, TerritoryDTO } from "src/app/features/map-features/sections/territories-section/Models/TerritoriesListItem";

@Injectable({
  providedIn: "root",
})
export class UnileverAPIService implements IApiBase{
  configUrl: string;

  constructor(private http: HttpClient) {
    this.configUrl = environment.host;
  }
  insert() {
    throw new Error("Method not implemented.");
  }
  update(datos: any) {
    throw new Error("Method not implemented.");
  }
  delete(id: any) {
    throw new Error("Method not implemented.");
  }
  getFilterValues(request: FilterRequest[]) {
    throw new Error("Method not implemented.");
  }
  getPage(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }
  getCount(pageRequest: CatalogPaginationRequest) {
    throw new Error("Method not implemented.");
  }

  GetLocationsByAGEBbyZoneUI(zone: string) {
    const request = { Zone: zone };
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/Unilever/HighPotencialZone_GetLocationsByAGEBbyZoneUI", request
    );
  }

  GetNearestRouteFrecuencyByCoordsUI(lat: string, lng: string) {
    const request = { Lat: lat, Lng: lng };
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/Unilever/RouteFrecuency_GetNearestRouteFrecuencyByCoordsUI", request
    );
  }

  GetPlanningTerritoriesFiltered(selectedFilters: TerritoriesFiltersSelected) {
    const region = selectedFilters.Region.description != "" ? selectedFilters.Region.description : null;
    const zone = selectedFilters.Zona.description != "" ? selectedFilters.Zona.description : null;
    const tipoRuta = selectedFilters.TipoRuta.length > 0 ? selectedFilters.TipoRuta : null;
    const diaVisita = selectedFilters.DiaVisita.length > 0 ? selectedFilters.DiaVisita : null;
    const frecuenciaRuta = selectedFilters.FrecuenciaRuta.length > 0 ? selectedFilters.FrecuenciaRuta : null;
    const request = { Region: region, Zone: zone, RouteTypes: tipoRuta, VisitDays: diaVisita, RouteFrecuency: frecuenciaRuta };
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/Unilever/PlanningTerritories_GetListFiltered", request
    );
  }

  PlanningTerritoriesGetFilters() {
    return this.http.get<EstatusJSON>(
      this.configUrl + "/api/Unilever/PlanningTerritories_GetFilters", {}
    );
  }

  GetPlanningTerritoriesDetails(selectedTerritory: TerritoryDTO) {
    const zone = selectedTerritory.zone != "" ? selectedTerritory.zone : null;
    const tipoRuta = selectedTerritory.routeType != "" ? selectedTerritory.routeType : null;
    const diaVisita = selectedTerritory.visitDay != "" ? selectedTerritory.visitDay : null;
    const frecuenciaRuta = selectedTerritory.routeFrequency != "" ? selectedTerritory.routeFrequency : null;
    const request = { Zone: zone, RouteType: tipoRuta, VisitDay: diaVisita, Frequency: frecuenciaRuta };
    return this.http.post<EstatusJSON>(
      this.configUrl + "/api/Unilever/PlanningTerritories_GetDetails", request
    );
  }
}
